import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s15_mobile px-4" }
const _hoisted_3 = { class: "widget px-7 py-7" }
const _hoisted_4 = { class: "form-field-floating active my-4" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "text-red"
}
const _hoisted_7 = { class: "form-field-floating reactive active my-4" }
const _hoisted_8 = {
  key: 1,
  class: "text-red"
}
const _hoisted_9 = {
  key: 2,
  class: "text-red"
}
const _hoisted_10 = {
  key: 3,
  class: "text-red"
}
const _hoisted_11 = {
  key: 4,
  class: "text-red"
}
const _hoisted_12 = { class: "flex gap-2" }
const _hoisted_13 = { class: "s5_mobile px-4" }
const _hoisted_14 = { class: "widget px-7 py-7" }
const _hoisted_15 = { class: "custom-upload-size margin-auto flex mb-8" }
const _hoisted_16 = { class: "custom-upload-size margin-auto flex mb-8" }

import { onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { QuillEditor } from '@vueup/vue-quill'
    import { useRoute, useRouter } from 'vue-router';
    import CustomUploadInput from '@/components/CustomUploadInput.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FaqFormView',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        id: "",
        libelle: "",
        contenu_aide: "",
        fichier_photo: null as any,
        fichier_photo_preview: '/assets/users/default.png',
        fichier_video: null as any,
        fichier_video_preview: '/assets/users/default.png',
        categorie_aide_id: ""
    });
    const errors = reactive({
        libelle: "",
        contenu_aide: "",
        fichier_photo: "",
        categorie_aide_id: "",
    });
    const startupFormDatas = reactive({
        categories: [] as any[]
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        startupFormDatas.categories = form_datas.categories;
        if (form_datas?.faq !== undefined) {
            const item = form_datas.faq as any;
            formData.id = item.id;
            formData.libelle = item.libelle;
            formData.contenu_aide = item.contenu_aide;
            if (item.fichier_photo !== undefined) {
                formData.fichier_photo_preview = item.fichier_photo_url;
            }
            if (item.fichier_video !== undefined) {
                formData.fichier_video_preview = item.fichier_video_url;
            }
            formData.categorie_aide_id = item.categorie_aide_id;
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;

        errors.libelle = '';
        if (!formData.libelle) {
            errors.libelle ="La question de la faq est requise";
            isValid = false;
        }

        errors.contenu_aide = '';
        if (!formData.contenu_aide) {
            errors.contenu_aide ="La réponse de la faq est requise";
            isValid = false;
        }

        errors.fichier_photo = '';
        if (!formData.id && !formData.fichier_photo) {
            errors.fichier_photo ="La photo est requise";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    function onFilePhotoUploaded(uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.fichier_photo_preview = uploadedFile.file_preview;
        formData.fichier_photo = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

    function onFileVideoUploaded(uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.fichier_video_preview = uploadedFile.file_preview;
        formData.fichier_video = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = new FormData();
            if (formData.id != null) {
                formToUpload.append("id", `${formData.id}`);
            }
            formToUpload.append("libelle", formData.libelle);
            formToUpload.append("contenu_aide", formData.contenu_aide);
            formToUpload.append("categorie_aide_id", formData.categorie_aide_id);
            if (formData.fichier_photo?.file) {
                formToUpload.append("fichier_photo", formData.fichier_photo.file, formData.fichier_photo.name);
            }
            if (formData.fichier_video?.file) {
                formToUpload.append("fichier_video", formData.fichier_video.file, formData.fichier_video.name);
            }

            await axios.post(`/backoffice/faq/save`, formToUpload);
            router.push('/app/faq/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
          _createTextVNode("FAQ / Edition "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            name: "categorie_aide_id",
            id: "categorie_aide_id",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.categorie_aide_id) = $event))
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("option", {
              value: "",
              selected: ""
            }, "Sélectionnez une catégorie", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupFormDatas.categories, (categorie, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: categorie.id,
                key: 'categorie_' + index
              }, _toDisplayString(categorie.libelle), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, formData.categorie_aide_id]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "categorie" }, [
            _createTextVNode("Catégorie "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['categorie_aide_id'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(errors['categorie_aide_id']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.libelle) = $event)),
            name: "libelle",
            id: "libelle",
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.libelle]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "libelle" }, [
            _createTextVNode("Question "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['libelle'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors['libelle']), 1))
          : _createCommentVNode("", true),
        _createVNode(_unref(QuillEditor), {
          id: "contenu_aide",
          content: formData.contenu_aide,
          "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((formData.contenu_aide) = $event)),
          contentType: "html",
          theme: "snow",
          style: {"height":"300px"}
        }, null, 8, ["content"]),
        (!!errors['contenu_aide'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(errors['contenu_aide']), 1))
          : _createCommentVNode("", true),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        (!!errors['fichier_photo'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(errors['fichier_photo']), 1))
          : _createCommentVNode("", true),
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_custom_button, {
            id: "btn-submit",
            type: "button",
            classesList: 'btn lg w-100',
            loading: loading.value,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Enregistrer", -1)
            ]))]),
            _: 1
          }, 8, ["loading"]),
          _cache[8] || (_cache[8] = _createElementVNode("button", { class: "btn stroke black lg" }, [
            _createElementVNode("span", null, "Effacer")
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "font-semibold mb-5 text-center" }, [
          _createTextVNode("Photo "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(CustomUploadInput, {
            id: "photo",
            label: "Photo",
            type: "IMAGE",
            preview: formData.fichier_photo_preview,
            onUploaded: onFilePhotoUploaded
          }, null, 8, ["preview"])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "font-semibold mb-5 text-center" }, [
          _createTextVNode("Vidéo "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(CustomUploadInput, {
            id: "video",
            label: "Vidéo",
            type: "VIDEO",
            preview: formData.fichier_video_preview,
            onUploaded: onFileVideoUploaded
          }, null, 8, ["preview"])
        ])
      ])
    ])
  ]))
}
}

})